import { PatternMap } from './models/patterns.interfaces';

export const namePatterns: PatternMap = {
  // Validates a first name: allows letters, hyphens, apostrophes, spaces and Ampersand, with a length between 1 and 56 characters.
  firstName: /^[a-zA-Z][a-zA-Z&\-'\s]{0,55}$/,
  // Validates a last name: similar to the first name pattern. Max length is 57.
  lastName: /^[a-zA-Z][a-zA-Z&\-'\s]{0,56}$/,
  // Validates a middle name: optional (empty string allowed), with similar rules as first and last names, but a max length of 56 characters.
  middleName: /^([a-zA-Z][a-zA-Z&\-'\s]{0,55}|)$/,
  // Validates a name suffix (e.g., Jr., Sr.): allows letters, spaces, hyphens, apostrophes, and dots, with a max length of 10 characters.
  nameSuffixCode: /^[a-zA-Z \-/'.]{1,10}$/,
  // Validates a name prefix (e.g., Mr., Mrs.): similar to nameSuffixCode, with a max length of 10 characters.
  namePrefixCode: /^[a-zA-Z \-/'.]{1,10}$/,
  // Validates a names only for Profile app - First, Middle & Last names: allows letters, hyphens, apostrophes, spaces and Ampersand, with a length of 35 characters.
  commonName: /^([a-zA-Z][a-zA-Z&\-'\s]{0,34}|)$/
};

export const addressPatterns: PatternMap = {
  // Validates the first line of an address: starts with alphanumeric characters, allows spaces, punctuation, and special characters, with a max length of 40 characters.
  addressLine1: /^[A-Za-z0-9][A-Za-z0-9\s.,'’#-]{0,39}$/,
  // Validates the second line of an address: same rules as addressLine1.
  addressLine2: /^[A-Za-z0-9][A-Za-z0-9\s.,'’#-]{0,39}$/,
  // Validates the name of a city or locality: starts with alphanumeric characters and allows similar characters as address lines, with a max length of 40 characters.
  cityLocalityName: /^[A-Za-z0-9][A-Za-z0-9\s.,'’-]{0,39}$/,
  // Validates the name of a district or town: similar to cityLocalityName.
  districtTownName: /^[A-Za-z0-9][A-Za-z0-9\s.,'’-]{0,39}$/,
  // Validates a postal code: allows alphanumeric characters, spaces, and punctuation, with a max length of 11 characters.
  postalCode: /^[A-Za-z0-9\s.,'’-]{1,11}$/,
  // Validates a country subdivision code (e.g., state, province): allows alphanumeric characters with a max length of 3 characters.
  countrySubdivisionCode: /^[A-Za-z0-9]{1,3}$/,
  // Validates an ISO country code: allows 2-3 alphabetic characters (e.g., US, CAN).
  isoCountryCode: /^[A-Za-z]{2,3}$/
};

export const contactPatterns: PatternMap = {
  // Validates a phone number: allows digits, hyphens, parentheses, and spaces, with a length between 6 and 15 characters.
  phone: /^[\d\-()\s]{6,15}$/,
  // Validates an email address: ensures the address is well-formed, with a max length of 132 characters, and prevents invalid characters or formats.
  email:
    /^(?=.{1,132}$)[a-zA-Z0-9](?!.*\.\.)(?:[a-zA-Z0-9._%+-]*[a-zA-Z0-9_%+-])?@[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,13}$/
};

export const securityPatterns: PatternMap = {
  // Validates a username: must include at least one letter and can contain alphanumeric characters, with a length between 6 and 132 characters.
  userName: /^(?=.*[A-Za-z])[A-Za-z0-9]{6,132}$/,
  // Validates a password: requires at least one uppercase, one lowercase, one digit, and allows a limited number of special characters, with a length between 8 and 20 characters.
  passwordText:
    /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=(?:[^!~`#$%^&*+=()_\-[\]{};':"\\|,.>/?]*[!~`#$%^&*+=()_\-[\]{};':"\\|,.>/?]){0,3}[^!~`#$%^&*+=()_\-[\]{};':"\\|,.>/?]*$)[A-Za-z0-9!~`#$%^&*+=()_\-[\]{};':"\\|,.>/?]{8,20}$/,
  // Validates a security answer: allows alphanumeric characters, hyphens, dots, apostrophes, and spaces, with a length between 4 and 40 characters.
  securityAns1: /^(?=([a-zA-Z0-9]){1,})([a-zA-Z0-9\-.'\s]){4,40}$/,
  // Validates a second security answer: identical rules as securityAns1.
  securityAns2: /^(?=([a-zA-Z0-9]){1,})([a-zA-Z0-9\-.'\s]){4,40}$/
};

export const securityTravelerPatterns: PatternMap = {
  // Validates a Known Traveler Number: must be exactly 9 alphanumeric characters.
  knownTravelerNumber: /^[a-zA-Z0-9]{8,25}$/,
  // Validates a Redress Number: must be exactly 7 digits.
  redressNumber: /^[0-9]{7}$/,
  // Validates a Canadian Traveler Number: must start with "CAN" and be exactly 13 characters in total, including the prefix.
  canadianTravelerNumber: /^CAN[a-zA-Z0-9]{10}$/
};

export const webUrlPatterns = /^\/([a-z]{2,5})\/([a-z]{2})\/(.+)$/;
export const removeDomainName = /^https?:\/\/[^/]+/;
